import { ParentTreeRepository } from './parent-tree-repository';
import { PathTreeRepository } from './path-tree-repository';

export class TreeRepositoryFactory {
    static getInstance(treeType: string){
        let repository=null;
        switch (treeType) {
            case "path":
                repository = new PathTreeRepository();
                break;
            case "parent":
                repository = new ParentTreeRepository();
                break;
            default: break;
        }
        return repository;
    }
}